import { User, UserManager, UserManagerSettings } from "oidc-client-ts";

let manager: UserManager | null = null;

// Shared so concurrent requests reuse a single in-flight silent renew.
let inflightRenew: Promise<User | null> | null = null;

const EXPIRY_LEEWAY_SECONDS = 60;

export function initUserManager(settings: UserManagerSettings): UserManager {
  if (!manager) {
    manager = new UserManager(settings);
  }
  return manager;
}

export function getUserManager(): UserManager | null {
  return manager;
}

export async function getValidAccessToken(): Promise<string | null> {
  if (!manager) {
    return null;
  }
  let user = await manager.getUser();
  if (!user) {
    return null;
  }

  const expiringSoon =
    user.expires_in != null && user.expires_in < EXPIRY_LEEWAY_SECONDS;

  if (user.expired || expiringSoon) {
    if (!inflightRenew) {
      inflightRenew = manager
        .signinSilent()
        .catch((error) => {
          console.error("Silent token renewal failed", error);
          return null;
        })
        .finally(() => {
          inflightRenew = null;
        });
    }
    user = await inflightRenew;
  }

  return user?.access_token ?? null;
}
